import { ButtonHTMLAttributes } from 'react'
import { cn } from 'utils/style'

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement>

export const IconButton = ({ className, type = 'button', ...props }: IconButtonProps) => (
	<button
		type={type}
		className={cn(
			'grid h-9 w-9 shrink-0 place-items-center rounded-md border border-border bg-background text-muted-foreground shadow transition-colors hover:bg-muted hover:text-foreground [&>svg]:h-4 [&>svg]:w-4 [&>svg]:stroke-2',
			className
		)}
		{...props}
	/>
)
